import { Card, Empty } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import AdditionalCosts from "@/components/Project/ProjectAdditionalCosts/AdditionalCosts";
import { useReferentialProjectCostTypes } from "@/entities/referential/referential-project-cost-types";

import { ProjectWithCostsType } from "./ProjectCostsCard.type";
import ProjectCostsCardContent from "./ProjectCostsCardContent";

import "./ProjectCostsCard.style.less";

const ProjectCostsCard = ({ project, loading }) => {
  const { t } = useTranslation();
  const { isLoading } = useReferentialProjectCostTypes();
  const showLoadingIndicator = loading || isLoading;

  return (
    <Card
      title={t("project:costsCard:title")}
      className="project-costs-card"
      loading={showLoadingIndicator}
      extra={!showLoadingIndicator && <AdditionalCosts project={project} />}
    >
      {project?.id ? <ProjectCostsCardContent project={project} /> : <Empty />}
    </Card>
  );
};

ProjectCostsCard.propTypes = {
  loading: PropTypes.bool,
  project: PropTypes.shape(ProjectWithCostsType),
};

export default ProjectCostsCard;
